export enum SlackNotificationEventType {
    HUMAN_INPUT_REQUESTED = 'HUMAN_INPUT_REQUESTED',
    HUMAN_INPUT_ANSWERED = 'HUMAN_INPUT_ANSWERED',
    TASK_COMPLETED = 'TASK_COMPLETED',
    STATUS_CHANGED = 'STATUS_CHANGED',
    PLAN_ITEM_ADDED = 'PLAN_ITEM_ADDED',
}

export enum SlackChannelOauthQueryParams {
    CHANNEL_ID = 'slackChannelId',
    CHANNEL_NAME = 'slackChannelName',
    WEBHOOK_URL = 'slackWebhookUrl',
}
export type SrtSlackNotificationConfig = {
    /**
     * Channel receiving notifications via incoming webhook. Null when only
     * direct-message notifications (dmOwnerOnCompletion) are enabled — DMs
     * are delivered with the bot token and need no channel/webhook.
     */
    channelId: string | null;
    channelName: string | null;
    webhookUrl: string | null;
    eventTypes: SlackNotificationEventType[];
    /**
     * When true, the task owner receives a bot DM when a task run completes.
     * Optional so legacy rows without the field deserialize fine; treat
     * missing as false.
     */
    dmOwnerOnCompletion?: boolean;
};

export type SrtBrowserNotificationConfig = {
    eventTypes: SlackNotificationEventType[];
};

export type SrtNotificationConfig = {
    slack: SrtSlackNotificationConfig | null;
    /** Quest-only browser delivery preferences. Absent on legacy rows. */
    browser?: SrtBrowserNotificationConfig | null;
};
